import Enum from 'cg-enum'

export const buyStatus = new Enum(
  [
    'notForSale',
    'forSale',
    'haltSales',
    'full',
    'immediatelyBuy',
    'disqualification6',
    'diagnose',
    'disqualification8',
    ' onSale',
    'payDeposit'
  ],
  1
)
buyStatus.earlyDiagnose = 16
buyStatus.diagnoseReport = 17
export const buyStatusName = {
  [buyStatus.notForSale]: '非卖品',
  [buyStatus.forSale]: '待售',
  [buyStatus.haltSales]: '停售',
  [buyStatus.full]: '报满',
  [buyStatus.immediatelyBuy]: '立即报名',
  [buyStatus.disqualification6]: '无报名资格6',
  [buyStatus.diagnose]: '诊断后报名',
  [buyStatus.disqualification8]: '无报名资格8',
  [buyStatus.onSale]: '待全面开售',
  [buyStatus.payDeposit]: '付定金',
  [buyStatus.earlyDiagnose]: '提前参与诊断',
  [buyStatus.diagnoseReport]: '查看诊断报告'
}



// WEBPACK FOOTER //
// ./src/defines/buyStatus.js